import React from 'react'

interface VerticalDottedLineProps {
  cx: number
  cy: number
  chartHeight: number
  color: string
}

export const VerticalDottedLine: React.FC<VerticalDottedLineProps> = ({
  cx,
  cy,
  chartHeight,
  color,
}) => {
  const lineHeight = chartHeight - cy - 20

  return (
    <line
      x1={cx}
      y1={cy}
      x2={cx}
      y2={cy + lineHeight}
      stroke={color}
      strokeWidth="8"
      strokeDasharray="6 8"
      strokeLinecap="round"
      style={{
        pointerEvents: 'none',
      }}
    />
  )
}
